module.exports = __webpack_public_path__ + "img/bg3.bd6bbbe0.png";